import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { SortOrder } from 'antd/es/table/interface';

dayjs.extend(isoWeek);

export const GLOBAL_CONSTANTS = {};

export const sortDirections: SortOrder[] = ['ascend', 'descend', 'ascend'];

export const PresetsMap: Record<string, [dayjs.Dayjs, dayjs.Dayjs]> = {
  ['Yesterday']: [
    dayjs().subtract(1, 'day').startOf('day'),
    dayjs().subtract(1, 'day').endOf('day'),
  ],
  ['This week']: [dayjs().startOf('isoWeek'), dayjs().endOf('isoWeek')],
  ['Last week']: [
    dayjs().subtract(1, 'week').startOf('isoWeek'),
    dayjs().subtract(1, 'week').endOf('isoWeek'),
  ],
  ['This month']: [dayjs().startOf('month'), dayjs().endOf('month')],
  ['Last month']: [
    dayjs().subtract(1, 'month').startOf('month'),
    dayjs().subtract(1, 'month').endOf('month'),
  ],
};
